<template>
  <div class="add-segment-holder">
    <div class="add-btn">
      <img :src="require('@/assets/svg/SVG/add_btn.svg')" />
    </div>
    <div class="add-segment-label">
      Add {{ type }}
    </div>
  </div>
</template>

<script>
import { usePrintStore } from '../../store/PrintStore';

export default {
  name: 'AddSegment',
  props: [
    'type'
  ],
  computed: {
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen;
    }
  }
};
</script>

<style scoped>
.add-segment-holder {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-left: 3px;
  margin-right: 3px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  position: sticky;
  right: 0px;
}
.add-segment-label {
  text-transform: capitalize;
  font-size: 80%;
  font-weight: bold;
  background-color:white;
  padding: 4px 8px;
  margin-left:5px;
  white-space: nowrap;
  -webkit-box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
  -moz-box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
  box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
}
.add-btn {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  -webkit-box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
  -moz-box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
  box-shadow: 6px 6px 17px -2px rgba(0,0,0,0.18);
}
</style>